/** Solo http(s); si el admin escribió "instagram.com/x" sin protocolo, se completa. */
export function safeUrl(raw: string | undefined): string | null {
  const v = (raw || '').trim();
  if (!v) return null;
  const url = /^https?:\/\//i.test(v) ? v : `https://${v.replace(/^\/+/, '')}`;
  try {
    const u = new URL(url);
    return u.protocol === 'http:' || u.protocol === 'https:' ? u.toString() : null;
  } catch {
    return null;
  }
}
